import {
  CreateCustomer,
  CreateCustomerProposal,
  EditCustomer,
  ToggleCustomer,
  CreateCustomerRep,
  EditCustomerRep,
  DeleteCustomerRep,
  EditCustomerProposal,
  EditCustomerProposalRequest,
  CreateCustomerProposalRequest,
} from '../actions/customers';
import { CustomerWithMeta } from '../models/Customer';
import Proposal from '../models/Proposal';
import ProposalRequest from '../models/ProposalRequest';
import axios from './axios';

export const fetchCustomers = async (): Promise<CustomerWithMeta[]> => {
  const { data } = await axios.get('/customers');

  return data;
};

export const createCustomer = async (properties: CreateCustomer) => {
  const { data } = await axios.post('/customers', properties);

  return data;
}

export const editCustomer = async (properties: EditCustomer) => {
  const { data } = await axios.put('/customers', properties);

  return data;
}

export const toggleCustomer = async (properties: ToggleCustomer) => {
  const { data } = await axios.put('/customers/active', properties);

  return data;
}

export const createCustomerRep = async (properties: CreateCustomerRep) => {
  const { data } = await axios.post('/customers/rep', properties);

  return data;
}

export const editCustomerRep = async (properties: EditCustomerRep) => {
  const { data } = await axios.put('/customers/rep', properties);

  return data;
}

export const deleteCustomerRep = async (properties: DeleteCustomerRep) => {
  return await axios.delete(`/customers/rep/id/${properties.id}`);
}

export const fetchCustomerProposals = async (): Promise<Proposal[]> => {
  const { data } = await axios.get('/customers/proposals');

  return data;
};

export const createCustomerProposal = async (properties: CreateCustomerProposal) => {
  const { data } = await axios.post('/customers/proposal', properties);

  return data;
}

export const editCustomerProposal = async (properties: EditCustomerProposal) => {
  const { data } = await axios.put('/customers/proposal', properties);

  return data;
}

export const fetchCustomerProposalRequests = async (): Promise<ProposalRequest[]> => {
  const { data } = await axios.get('/customers/proposal-requests');

  return data;
};

export const createCustomerProposalRequest = async (properties: CreateCustomerProposalRequest) => {
  const { data } = await axios.post('/customers/proposal-request', properties);

  return data;
}

export const editCustomerProposalRequest = async (properties: EditCustomerProposalRequest) => {
  const { data } = await axios.put('/customers/proposal-request', properties);

  return data;
}

export const downloadImportTemplate = async () => {
  const response = await axios.get('/customers/import/template', {
    responseType: 'blob',
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'customers-import-template.xlsx');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export const importCustomers = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  await axios.post('/customers/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}